import React from "react"
import { motion } from "framer-motion"
import { twMerge } from "tailwind-merge"

interface CardProps {
  children?: React.ReactNode
  className?: string
  hover?: boolean
  onClick?: () => void
}

const Card: React.FC<CardProps> = ({ children, className = "", hover = false, onClick }) => {
  const baseClasses = "bg-white dark:bg-slate-900 rounded-xl shadow-lg border border-legacy-light/20 p-4"
  const hoverClasses = hover ? "hover:shadow-xl transition-shadow duration-300 cursor-pointer" : ""
  const clickableClasses = onClick ? "cursor-pointer" : ""

  const classes = twMerge(className, baseClasses, hoverClasses, clickableClasses)

  const CardComponent = <div onClick={onClick}>{children}</div>

  if (hover || onClick) {
    return (
      <motion.div
        className={classes}
        whileHover={{ scale: 1.01 }}
        // whileTap={{ scale: 0.98 }}
        transition={{ duration: 0.2 }}
      >
        {CardComponent}
      </motion.div>
    )
  }

  return (
    // initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}
    <motion.div className={classes}>{children}</motion.div>
  )
}

export default Card
